import { getWithAuth } from '../InitializeService';
import { AxiosInstance } from 'axios';
import { buildODataQuery, ODataParams } from '@/utils/odataUtil';

export const getCurrentUser = (instance: AxiosInstance) => {
  return getWithAuth('me', instance);
}
export const getByLoginName = (loginName: string, instance: AxiosInstance) => {
  return getWithAuth(`users?loginname=${encodeURIComponent(loginName)}`, instance);
}
export const searchStaffByName = (instance: AxiosInstance, name: string) => {
  return getWithAuth(`users${buildODataQuery({
    filter: `(contains(FullName,'${name}') or contains(LoginName,'${name}')) and active eq true`,
    orderby: 'fullName',
    top: 10,
    skip: 0,
  })}`, instance);
}
export const getUserProfileForCurrentUser = (loginName: string, instance: AxiosInstance) => {
  return getWithAuth(`sharepoint/userProfiles?userId=positive\\${loginName}&siteUrl=https://sharepoint.teampbs.com`, instance);
};
export const getAccessControl = (instance: AxiosInstance) => {
  return getWithAuth(`mysite/accesscontrol`, instance)
}

export const getUsersWithFilters = (params: ODataParams, instance: AxiosInstance) => {
    return getWithAuth(`users${buildODataQuery(params)}`, instance);
};
export const getStaffingUsersWithFilters = (params: ODataParams, instance: AxiosInstance) => {
    return getWithAuth(`staffing/dashboard/staff${buildODataQuery(params)}`, instance);
}
export const getDistinctStaffCities = (filter: string, instance: AxiosInstance) => {
    return getWithAuth(`users/cities?$apply=filter(${filter})/groupby((City))&$orderby=City asc`, instance);
};
export const getProfilePicture = (instance: AxiosInstance) => {
  return getWithAuth(`me/profilepicture?size=S`, instance, { responseType: 'blob' });
}